import React from "react";

export default function ProposalUnavailablePage() {
  return (
    <div
      style={{
        maxWidth: 560,
        margin: "80px auto",
        padding: "0 20px",
        textAlign: "center",
      }}
    >
      <div style={{ fontSize: 48, marginBottom: 16 }}>ℹ️</div>
      <h1 style={{ marginBottom: 16, fontSize: 28, fontWeight: 700 }}>
        This proposal link is no longer available
      </h1>
      <p style={{ fontSize: 17, lineHeight: 1.6, color: "#444" }}>
        The proposal may have been withdrawn or updated. Please contact your
        representative if you need a new copy.
      </p>
    </div>
  );
}
